import { render, staticRenderFns } from "./associated_terminals.vue?vue&type=template&id=afa2238e&scoped=true"
import script from "./associated_terminals.vue?vue&type=script&lang=js"
export * from "./associated_terminals.vue?vue&type=script&lang=js"
import style0 from "./associated_terminals.vue?vue&type=style&index=0&id=afa2238e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa2238e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afa2238e')) {
      api.createRecord('afa2238e', component.options)
    } else {
      api.reload('afa2238e', component.options)
    }
    module.hot.accept("./associated_terminals.vue?vue&type=template&id=afa2238e&scoped=true", function () {
      api.rerender('afa2238e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/position_information/associated/associated_terminals/associated_terminals.vue"
export default component.exports